import auth from './auth';
import Config from "app-core/config";

export default {
	quote: [
		{
			text: () => Config.getVueApp().$tCaption('Home', '@app-navigation'),
			path: '/home',
			icon: 'home',
			hidden: () => !auth.hasCommonNavigationAccess()
		},
		{
			text: () => Config.getVueApp().$tCaption('Proposal builder', '@app-navigation'),
			path: '/proposal/Builder',
			icon: 'globe',
			hidden: () => !auth.hasCommonNavigationAccess()
		},
		{
			text: () => Config.getVueApp().$tCaption('Quote proposals', '@app-navigation'),
			path: '/quote-proposal/List',
			icon: 'bulletlist',
			hidden: () => !auth.hasCommonNavigationAccess()
		}
	],
	default: [
		{
			text: () => Config.getVueApp().$tCaption('Home', '@app-navigation'),
			path: '/home',
			icon: 'home'
		},
		{
			text: () => Config.getVueApp().$tCaption('My stations', '@app-navigation'),
			path: '/station/List',
			icon: 'fas fa-broadcast-tower',
			hidden: () => !auth.hasCommonNavigationAccess()
		},
		{
			text: () => Config.getVueApp().$tCaption('Invoices', '@app-navigation'),
			path: '/invoice/List',
			icon: 'fas fa-file-invoice',
			hidden: () => auth.countryCode() !== 'US' || !auth.hasCommonNavigationAccess()
		},
		{
			text: () => Config.getVueApp().$tCaption('Station logs', '@app-navigation'),
			path: '/reconciliation/stations-log',
			icon: 'fas fa-calendar-day',
			hidden: () => !auth.isStationOwner() || !auth.hasCommonNavigationAccess()
		},
		{
			text: () => Config.getVueApp().$tCaption('Creative studio', '@app-navigation'),
			icon: 'fas fa-square-poll-horizontal',
			expanded: true,
			hidden: () => !auth.allowCreativeStudio(),
			items: [
				{
					text: () => Config.getVueApp().$tCaption('Creatives', '@app-navigation'),
					path: '/creative/List',
					icon: 'fas fa-file-audio'
				},
				{
					text: () => Config.getVueApp().$tCaption('AI Song', '@app-navigation'),
					path: '/ai-music/List',
					icon: 'fas fa-music',
					hidden: () => !auth.canManageAiMusic()
				},
				{
					text: () => Config.getVueApp().$tCaption('Dynamic rules', '@app-navigation'),
					path: '/eventRules/List',
					icon: 'filter',
					hidden: () => !auth.hasCreativeApi()
				},
				{
					text: () => Config.getVueApp().$tCaption('Geo targets', '@app-navigation'),
					path: '/geo-targets/List',
					icon: 'fas fa-map-marked-alt',
					hidden: () => !auth.hasCreativeApi()
				},
				{
					text: () => Config.getVueApp().$tCaption('Schedule', '@app-navigation'),
					path: '/persistent-schedule/List',
					icon: 'fas fa-clock',
					hidden: () => !auth.hasCreativeApi()
				},
				{
					text: () => Config.getVueApp().$tCaption('Voices showcase', '@app-navigation'),
					path: '/voices-showcase',
					icon: 'fas fa-grip',
					hidden: () => !auth.isAdmin()
				},
				{
					text: () => Config.getVueApp().$tCaption('Voice cloning', '@app-navigation'),
					path: '/voice-creator',
					icon: 'fas fa-file-waveform',
					//hidden: () => !auth.isAdmin()
				},
			]
		},
		{
			text: () => Config.getVueApp().$tCaption('Briefs', '@app-navigation'),
			path: '/briefs',
			icon: 'fas fa-scroll',
			hidden: () => !auth.isAdmin(),
		},
		{
			text: () => Config.getVueApp().$tCaption('Proposals', '@app-navigation'),
			path: '/proposal/List',
			icon: 'fas fa-square-pen',
			hidden: () => !auth.isAdmin(),
		},
		{
			text: () => Config.getVueApp().$tCaption('Campaigns', '@app-navigation'),
			path: '/campaign/List',
			icon: 'bulletlist',
			hidden: () => !auth.hasCreativeApi() || !auth.hasCommonNavigationAccess(),
			items: [
				{
					text: () => Config.getVueApp().$tCaption('Admin dashboard', '@app-navigation'),
					path: '/logs/AdminDashboard',
					icon: 'fas fa-chart-line',
					hidden: () => !auth.isAdmin(),
				},
				{
					text: () => Config.getVueApp().$tCaption('Dashboard', '@app-navigation'),
					path: '/logs/dashboard',
					icon: 'fas fa-chart-line'
				},
				{
					text: () => Config.getVueApp().$tCaption('Airtime log', '@app-navigation'),
					path: '/logs/airtime',
					icon: 'fas fa-tower-broadcast'
				}
			],
		},
		{
			text: () => Config.getVueApp().$tCaption('Network shows', '@app-navigation'),
			path: '/network-shows',
			icon: 'fas fa-project-diagram',
			hidden: () => !(auth.isAdmin() || (auth.isStationOwner() && auth.hasCommonNavigationAccess())),
		},
		{
			text: () => Config.getVueApp().$tCaption('Network Studio', '@app-navigation'),
			icon: 'fas fa-project-diagram',
			expanded: true,
			hidden: () => !((auth.hasNetworkStudio() && auth.hasCommonNavigationAccess()) || auth.isAdmin()),
			items: [
				{
					text: () => Config.getVueApp().$tCaption('Show', '@app-navigation'),
					path: '/network-studio/shows',
					icon: 'far fa-gem',
					hidden: () => !(auth.hasNetworkStudio() || auth.isAdmin()),
				},
			],
		},
		{
			text: () => Config.getVueApp().$tCaption('Administration', '@app-navigation'),
			icon: 'fas fa-hammer',
			expanded: true,
			hidden: () => !auth.isAdmin(),
			items: [
				{
					text: () => Config.getVueApp().$tCaption('Localization', '@app-navigation'),
					path: '/admin/localization',
					icon: 'fas fa-language',
					hidden: () => !auth.isAdmin(),
				},
				{
					text: () => Config.getVueApp().$tCaption('Creative Templates', '@app-navigation'),
					path: '/products/creatives/templates/List',
					icon: 'fas fa-list',
					hidden: () => !auth.isAdmin(),
				},
				{
					text: () => Config.getVueApp().$tCaption('Speech to text manager', '@app-navigation'),
					path: '/speech-to-text-manager',
					icon: 'fas fa-list',
					hidden: () => !auth.isAdmin(),
				},
			],
		},
	]
};
